module.exports = __webpack_public_path__ + "img/logo-DHS-RDS.a0afee48.png";